export const whereBoughtData = {
  buttons: [
    {
      label: 'A car dealer',
      id: 'dealer',
    },
    {
      label: 'A private seller, or at auction',
      id: 'private',
    },
  ],
  title: 'Where did you buy your car from?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/82a41b02157d-tooliconlocationpin.jpg',
  },
}
